module.exports = __webpack_public_path__ + "static/media/joyable2.59136be5.jpg";